import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
    selector: 'completed-payment-method-bank-slip',
    templateUrl: './completed.payment-method.bank-slip.component.html',
    styleUrls: ['./../../completed.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class CompletedPaymentMethodBankSlipComponent {
    @Input('paymentCode') paymentCode;
    @Input('bankSlipUrl') bankSlipUrl;
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/completed/payment-method/bank-slip/completed.payment-method.bank-slip.component.ts